export const routePaths = [
  '/',
  '/employment',
  '/employment/application-submitted',
  '/jobs/:slug',
  '/works',
  '/services',
  '/products',
  '/autonomous-vehicle',
  '/company-info',
  '/locations',
  '/privacy-policy',
  '/thanks',
  '/articles/202004300900_share_transfer',
  '/articles/20200314090000_new',
  '/articles/20200314100000_excelout',
  '/products/timehunt_privacy_policy',
  '*',
] as const;

export type RoutePath = (typeof routePaths)[number];

export const staticRoutePaths = routePaths.filter(
  (path) => !path.includes(':') && path !== '*'
);